var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "productRecordModal",
      attrs: { id: "product-record-modal", title: "Add product", size: "lg" },
      scopedSlots: _vm._u([
        {
          key: "modal-footer",
          fn: function () {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-content-end" },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: { click: _vm.handleCancel },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      staticClass: "ml-2",
                      attrs: { variant: "primary" },
                      on: { click: _vm.handleSave },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.mode === "create"
                              ? "Add product"
                              : "Update product"
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Product Image" } },
                [
                  _c("ProductImageSelect", {
                    attrs: {
                      value: _vm.productImage ? [_vm.productImage] : [],
                    },
                    on: { "updated-image": _vm.handleUpdatedImage },
                  }),
                  _vm._v(" "),
                  _vm.errors.productImage
                    ? _c(
                        "div",
                        { staticClass: "small text-danger font-italic" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.errors.productImage) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Product Name" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    model: {
                      value: _vm.productName,
                      callback: function ($$v) {
                        _vm.productName = $$v
                      },
                      expression: "productName",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.productName
                    ? _c(
                        "div",
                        { staticClass: "small text-danger font-italic" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.errors.productName) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "GTIN" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    model: {
                      value: _vm.gtin,
                      callback: function ($$v) {
                        _vm.gtin = $$v
                      },
                      expression: "gtin",
                    },
                  }),
                  _vm._v(" "),
                  _vm.errors.gtin
                    ? _c(
                        "div",
                        { staticClass: "small text-danger font-italic" },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.errors.gtin) +
                              "\n        "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "UPC" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    model: {
                      value: _vm.upc,
                      callback: function ($$v) {
                        _vm.upc = $$v
                      },
                      expression: "upc",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Brand" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    model: {
                      value: _vm.brand,
                      callback: function ($$v) {
                        _vm.brand = $$v
                      },
                      expression: "brand",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Variant" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "text" },
                    model: {
                      value: _vm.variant,
                      callback: function ($$v) {
                        _vm.variant = $$v
                      },
                      expression: "variant",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Primary Color" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "color" },
                    model: {
                      value: _vm.primaryColor,
                      callback: function ($$v) {
                        _vm.primaryColor = $$v
                      },
                      expression: "primaryColor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-col",
            { attrs: { cols: "6" } },
            [
              _c(
                "b-form-group",
                { attrs: { label: "Secondary Color" } },
                [
                  _c("b-form-input", {
                    staticClass: "form-control",
                    attrs: { type: "color" },
                    model: {
                      value: _vm.secondaryColor,
                      callback: function ($$v) {
                        _vm.secondaryColor = $$v
                      },
                      expression: "secondaryColor",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }